<!-- header.component.html -->

<nav class="navbar navbar-expand-lg bg-primary position-relative">
  <div class="container-fluid">
    <!-- Left Side: Home Button and Property Address -->
    <div class="left-content d-flex align-items-center">
      <!-- Home Button -->
      <button
        *ngIf="showHomeButton"
        class="btn btn-link text-light"
        (click)="onHomeClick()">
        <i class="bi bi-house-fill" style="font-size: 30px;"></i>
      </button>
      <!-- Property Address -->
      <span
        *ngIf="!showTitle"
        class="navbar-brand text-light property-address">
        {{ propertyAddress }}
      </span>
    </div>

    <!-- Center: Title -->
    <div *ngIf="showTitle" class="title-container">
      <span class="navbar-brand text-light m-0 nav-title">
        {{ title }}
      </span>
    </div>

    <!-- Right Side: Status and Save/Edit Buttons -->
    <div *ngIf="showStatus" class="right-content d-flex align-items-center">
      <span class="navbar-brand text-light status-text nav-status">
        Status: {{ details?.reportStatus }}
      </span>
      <!-- Save/Edit Buttons -->
      <app-save-edit
        *ngIf="showSaveEdit && !loading && (isHealthy$ | async) && details?.reportStatus !== 'LODGED'"
        [isEditVisible]="isEditVisible"
        [isEdit]="isEdit"
        [saving]="saving"
        [form]="form"
        (save)="onSave($event)"
        (cancel)="onCancel()">
      </app-save-edit>
    </div>
  </div>
</nav>

<!-- Health Status -->
<app-health-status
  *ngIf="(isHealthy$ | async) === false"
  [isHealthy]="isHealthy$ | async">
</app-health-status>